import { render } from "./AdminDomainOrders.vue?vue&type=template&id=729236ac"
import script from "./AdminDomainOrders.vue?vue&type=script&lang=js"
export * from "./AdminDomainOrders.vue?vue&type=script&lang=js"

import "./AdminDomainOrders.vue?vue&type=style&index=0&id=729236ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__